import * as wsj from './colors-wsj';
import * as barrons from './colors-barrons';
import * as fnlondon from './colors-financialnews';
import * as marketwatch from './colors-marketwatch';
import * as mansionglobal from './colors-mansionglobal';
import * as djriskjournal from './colors-djriskjournal';
import getFilter from '../util/getFilter';

export function getWsjColorArr(obj, result = []) {
  const arr = [];
  Object.keys(obj).forEach((key) => {
    const value = obj[key];
    typeof value === 'string' ? arr.push(value) : getWsjColorArr(value, result);
  });
  result.push(...arr);
  return result;
}

const COLORS = [].concat(
  getWsjColorArr(wsj.WSJ_COLORS),
  barrons.BARRONS_COLORS,
  fnlondon.FNLONDON_COLORS,
  marketwatch.MARKETWATCH_COLORS,
  mansionglobal.MANSIONGLOBAL_COLORS,
  djriskjournal.DJ_RISKJOURNAL_COLORS
);
// TODO: consider removing combined theme
export const COLOR_THEMES = {
  ...wsj.WSJ_COLOR_THEMES,
  ...barrons.BARRONS_COLOR_THEMES,
  ...djriskjournal.DJ_RISKJOURNAL_COLOR_THEMES,
  ...fnlondon.FNLONDON_COLOR_THEMES,
  ...marketwatch.MARKETWATCH_COLOR_THEMES,
  ...mansionglobal.MANSIONGLOBAL_COLOR_THEMES,
};

export const PLOT_LINE_COLORS = [].concat(
  wsj.WSJ_PLOT_LINE_COLORS,
  barrons.BARRONS_PLOT_LINE_COLORS,
  djriskjournal.DJ_RISKJOURNAL_PLOT_LINE_COLORS,
  fnlondon.FNLONDON_PLOT_LINE_COLORS,
  marketwatch.MARKETWATCH_PLOT_LINE_COLORS,
  mansionglobal.MANSIONGLOBAL_PLOT_LINE_COLORS
);

const colorTheme = findDefaultColorTheme();
export function findDefaultColorTheme() {
  let target = getFilter().targets[0];
  target = target === 'wsj' ? 'wsj_world' : target;
  return COLOR_THEMES[target];
}
export const DEFAULT_COLOR_THEME = colorTheme;

export const TRANSPARENT = 'rgba(0, 0, 0, 0)';

export const LINES = ['solid', 'dotted'];

export const INDEXES = {
  wsj: ['#bebebe', '#717171', '#323232'],
  wsj_video: ['#999999', '#777777', '#555555'],
  barrons: ['#C6CCD1', '#6F7878'],
  djriskjournal: ['#bebebe', '#717171', '#323232'],
  fnlondon: ['#C6D7E4', '#99A8B6', '#4D6172'],
  marketwatch: ['#919191', '#4d4d4d'],
  mansionglobal: ['#b9b7b8', '#818080', '#4a4949'],
};

export function getColorThemesForProduct(product) {
  switch (product) {
    case 'wsj':
      return wsj.WSJ_COLOR_THEMES;
    case 'barrons':
      return barrons.BARRONS_COLOR_THEMES;
    case 'djriskjournal':
      return djriskjournal.DJ_RISKJOURNAL_COLOR_THEMES;
    case 'fnlondon':
      return fnlondon.FNLONDON_COLOR_THEMES;
    case 'marketwatch':
      return marketwatch.MARKETWATCH_COLOR_THEMES;
    case 'mansionglobal':
      return mansionglobal.MANSIONGLOBAL_COLOR_THEMES;
    default:
      console.error(
        `Color theme for ${product} publication doesn't exist. wsj.WSJ, barrons, djriskjournal, fnlondon, marketwatch and mansion global are valid publications`
      );
      return {};
  }
}

export function colorsForProduct(product) {
  switch (product) {
    case 'wsj':
      return wsj.WSJ_COLORS;
    case 'barrons':
      return barrons.BARRONS_COLORS;
    case 'djriskjournal':
      return djriskjournal.DJ_RISKJOURNAL_COLORS;
    case 'fnlondon':
      return fnlondon.FNLONDON_COLORS;
    case 'marketwatch':
      return marketwatch.MARKETWATCH_COLORS;
    case 'mansionglobal':
      return mansionglobal.MANSIONGLOBAL_COLORS;
    default:
      return COLORS;
  }
}

export const plotLineColorsForProduct = (product) => {
  switch (product) {
    case 'wsj':
      return wsj.WSJ_PLOT_LINE_COLORS;
    case 'barrons':
      return barrons.BARRONS_PLOT_LINE_COLORS;
    case 'djriskjournal':
      return djriskjournal.DJ_RISKJOURNAL_PLOT_LINE_COLORS;
    case 'fnlondon':
      return fnlondon.FNLONDON_PLOT_LINE_COLORS;
    case 'marketwatch':
      return marketwatch.MARKETWATCH_PLOT_LINE_COLORS;
    case 'mansionglobal':
      return mansionglobal.MANSIONGLOBAL_PLOT_LINE_COLORS;
    default:
      return PLOT_LINE_COLORS;
  }
};

export function getArrowIcon(prop) {
  const direction = prop ? 'up' : 'down';
  return `arrow_drop_${direction}`;
}

export const PIE_COLORS = {
  barrons: barrons.BARRONS_PIE_THEME,
  marketwatch: marketwatch.MARKETWATCH_PIE_THEME,
  mansionglobal: mansionglobal.MANSIONGLOBAL_PIE_THEME,
  fnlondon: fnlondon.FNLONDON_PIE_THEME,
};

export default COLORS;
